import OrgAdminLayout from '../components/OrgAdminLayout';
import DocumentsBrowser from '../components/DocumentsBrowser';

// Org-wide document library, browsed as a file cabinet: clients first (all data
// is a client's), then category folders inside each client, then the documents.
// A pinned "Suspense" bucket holds uploads that arrived without a client, from
// where they can be filed into any client/folder. (The per-client page still
// embeds DocumentsManager directly for that one client's vault.)
function OrgAdminDocuments() {
  return (
    <OrgAdminLayout title="Documents" subtitle="Your firm's document library">
      <DocumentsBrowser />
    </OrgAdminLayout>
  );
}

export default OrgAdminDocuments;
